import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import reportActions from '../report/reportActions';

import { Page, PageContent } from '../components/common';
import AdminHomePageCell from './AdminHomePageCell';
import { ensureUserHasRoleAdminSite } from '../auth/authComponents';
import { SecurityRoles } from '../common/utils';

interface Props {
	className?: string;
	actions: any;
	customersCount: PeriodCountDto;
	policiesCount: PeriodCountDto;
	unmailedPoliciesCount: UnmailedPolicyCountDto;
	failedPaymentsCount: number;
	expiringPoliciesCount: number;
	missingBeneficiaryFormsCount: number;
	bouncedEmailsCount: number;
}
class AdminHomePage extends React.Component<Props> {
	componentDidMount() {
		this.props.actions.fetchCustomersCount();
		this.props.actions.fetchPoliciesCount();
		this.props.actions.fetchUnmailedPoliciesCount();
		this.props.actions.fetchFailedPaymentsCount();
		this.props.actions.fetchExpiringPoliciesCount();
		this.props.actions.fetchMissingBeneficiaryFormsCount();
		this.props.actions.fetchBouncedEmailsCount();
	}

	getLastMonth = () => {
		const months = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December'
		];
		let lastMonth = new Date().getMonth() - 1;
		if (lastMonth < 0) {
			lastMonth = 11;
		}
		return months[lastMonth];
	}

	render() {
		return (
			<Page title="Dashboard">
				<PageContent sectionClassName="dashboard p-0">
					<div className="dashboard-row">
						<AdminHomePageCell
							className="bg-secondary text-light admin-dashboard-cell-lg"
							title="Customers"
							value={this.props.customersCount.total}
							subValue={`${this.props.customersCount.month} in ${this.getLastMonth()}`}
							to="/admin/reports/user-activity"
							linkLabel="View activity"
						/>
						<AdminHomePageCell
							className="admin-dashboard-cell-lg dashboard-col"
							title="Policies created"
							value={this.props.policiesCount.total}
							subValue={`${this.props.policiesCount.month} in ${this.getLastMonth()}`}
							to="/admin/reports/policies-created"
							linkLabel="View policies"
						/>
						<AdminHomePageCell
							className="admin-dashboard-cell-lg dashboard-col"
							title="Unmailed policies"
							value={this.props.unmailedPoliciesCount.total}
							subValue={`${this.props.unmailedPoliciesCount.month} in ${this.getLastMonth()}`}
							to="/admin/reports/policies-unmailed"
							linkLabel="View unmailed policies"
						/>
					</div>
					<div className="dashboard-row">
						<AdminHomePageCell
							className="dashboard-col text-primary"
							title="Policies expiring in 30 days"
							value={this.props.expiringPoliciesCount}
							to="/admin/reports/policies-expiring"
							linkLabel="View expiring policies"
						/>
						<AdminHomePageCell
							className="dashboard-col text-primary"
							title="Failed payments"
							value={this.props.failedPaymentsCount}
							to="/admin/reports/failed-payments"
							linkLabel="View failed payments"
						/>
						<AdminHomePageCell
							className="dashboard-col text-primary"
							title="Missing beneficiary forms"
							value={this.props.missingBeneficiaryFormsCount}
							to="/admin/reports/missing-beneficiary-forms"
							linkLabel="View customers"
						/>
						<AdminHomePageCell
							className="dashboard-col text-primary"
							title="Bounced emails in the past 30 days"
							value={this.props.bouncedEmailsCount}
							to="/admin/reports/bounced-emails"
							linkLabel="View bounced emails"
						/>
					</div>
				</PageContent>
			</Page>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		customersCount: state.report.customersCount,
		policiesCount: state.report.policiesCount,
		unmailedPoliciesCount: state.report.unmailedPoliciesCount,
		failedPaymentsCount: state.report.failedPaymentsCount,
		expiringPoliciesCount: state.report.expiringPoliciesCount,
		missingBeneficiaryFormsCount: state.report.missingBeneficiaryFormsCount,
		bouncedEmailsCount: state.report.bouncedEmailsCount,
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...reportActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connector = connect(mapStateToProps, mapDispatchToProps)(AdminHomePage);
export default ensureUserHasRoleAdminSite(connector as any, [SecurityRoles.Administrator, SecurityRoles.Agent]);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/AdminHomePage.tsx